<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-05 10:32:54
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-11 10:56:23
 * @FilePath: /chaoyongtuan/src/views/shopManage/addMaterial/addMaterial.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="pb-24 adMaterial-content">
		<Good :queryParams="queryParams" ref="goods" :isBatch="isBatch" />
		<Local ref="local" :isBatch="isBatch" :materialData="{ material_details_video, material_details_pic }" />
		<div class="footer">
			<el-button type="" @click="cancel">取消</el-button>
			<el-button type="primary" @click="save" :loading="loading">保存</el-button>
		</div>
	</div>
</template>
<script>
import Good from './components/good/good.vue';
import Local from './components/local/local.vue';
import { batchAddMaterial, editMaterialInfo } from '@/api/shopManage.js';
import { gettMaterial } from '@/api/shopManage.js';
export default {
	data() {
		return {
			material_details_video: [],
			material_details_pic: [],
			loading: false,
			goodsList: [],
		};
	},
	computed: {
		queryParams() {
			return this.$route.query;
		},
		isBatch() {
			return this.queryParams.batch == 1;
		},
	},
	created() {
		this.$nextTick(() => {
			!this.isBatch && this.getSingleGoodsMaterial();
		});
	},
	methods: {
		/**
		 * 返回
		 */
		cancel() {
			this.$modal({
				title: '确认取消？',
				contentTitle: '取消编辑将清空本次编辑内容，确认取消？',
				size: 'small',
				btns: [
					{
						type: 'default',
						text: '取消',
						key: 'cancel',
					},
					{
						type: 'primary',
						text: '确认取消',
						key: 'confirm',
					},
				],
			}).then(res => {
				if (res.key == 'confirm') {
					this.isSave = true;
					this.isBatch ? localStorage.removeItem('goodsList') : '';
					history.go(-1);
					res.done();
				} else {
					res.done();
				}
			});
		},
		/**
		 *  获取本地素材 商品信息的数据
		 */
		generateParams() {
			const product_infos = this.$refs.goods?.getData();
			const { material_infos, material_pic_ids, material_video_ids } = this.$refs.local.getData();
			const platform_id = this.queryParams.platformId;
			if (this.isBatch) {
				return {
					product_infos,
					platform_id,
					material_pic_ids,
					material_video_ids,
				};
			} else {
				return {
					platform_id,
					...product_infos[0],
					material_infos,
					material_pic_ids,
					material_video_ids,
				};
			}
		},
		/**
		 * 保存
		 */
		async save() {
			try {
				let goodsLength =  this.$refs.goods?.getData().length
				// 校验单个编辑素材的时候 后端返回数据为空 前端做校验 (后续产品加需求,后端给字段在入口在判断)
				if(!this.isBatch && !goodsLength){
					return this.$message.error('请先选择推广中活动商品后提交')
				}
				if(this.isBatch && !goodsLength){
					return this.$message.error('请添加商品')
				}
				this.loading = true;
				const params = this.generateParams();
				await (this.isBatch ? batchAddMaterial : editMaterialInfo)(params);
				this.$message.success('更新素材成功');
				this.isSave = true;
				this.isBatch ? localStorage.removeItem('goodsList') : '';
				history.go(-1);
			} finally {
				this.loading = false;
			}
		},
		async getSingleGoodsMaterial() {
			const params = {
				third_product_id: this.queryParams.thirdProductId,
				platform_id: this.queryParams.platformId,
			};
			const { list: material_details_video } = await gettMaterial({ ...params, material_type: 1 });
			const { list: material_details_pic } = await gettMaterial({ ...params, material_type: 2 });
			this.material_details_video = material_details_video;
			this.material_details_pic = material_details_pic;
		},
	},
	beforeRouteLeave(to, from, next) {
		// 导航离开该组件的对应路由时调用
		// 可以访问组件实例 `this`
		if (this.isSave) {
			return next();
		}
		this.$modal({
			title: '确认取消？',
			contentTitle: '取消编辑将清空本次编辑内容，确认取消？',
			size: 'small',
			btns: [
				{
					type: 'default',
					text: '取消',
					key: 'cancel',
				},
				{
					type: 'primary',
					text: '确认取消',
					key: 'confirm',
				},
			],
		}).then(res => {
			if (res.key == 'confirm') {
				this.isBatch ? localStorage.removeItem('goodsList') : '';
				next();
				res.done();
			} else {
				history.go(1);
				res.done();
			}
		});
	},
	components: {
		Good,
		Local,
	},
};
</script>
<style lang="less" scoped>
.footer {
	position: absolute;
	width: calc(100% - 55px);
	left: 15px;
	bottom: 0;
	padding: 10px;
	display: flex;
	justify-content: center;
	border-top: 1px solid #f0f1f5;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
	background-color: #fff;
	z-index: 999;
}
.adMaterial-content {
	margin-bottom: 80px;
}
</style>
